export const about = {
  is: {
    title: "Leiðandi í þróun stafrænna lausna",
    description: "Við höfum verið í fararbroddi í þróun stafrænna lausna í næstum tvo áratugi. Með dreift teymi í þremur löndum og áherslu á nýsköpun, erum við í kjörstöðu til að hjálpa fyrirtækjum að ná árangri í stafrænum heimi.",
    history: {
      title: "Saga okkar og þróun",
      description: "Vefsíða hefur verið leiðandi í þróun stafrænna lausna síðan 2006. Lengst af höfðum við aðsetur á Suðurlandsbraut 16 í Reykjavík, en árið 2020 tókum við stefnumarkandi ákvörðun um að verða dreift teymi eftir að hafa upplifað aukna framleiðni og betri árangur í fjarvinnu á tímum Covid.",
      current: "Í dag eru höfuðstöðvar okkar dreifðar um heiminn, með starfsstöðvar í Reykjavík, Kaupmannahöfn og Barcelona. Við sérhæfum okkur í notkun gervigreindar til að hámarka afköst og nýsköpun í stafrænum lausnum okkar."
    },
    values: {
      title: "Gildi okkar",
      description: "Við byggjum allt okkar starf á sterkum gildum sem leiða okkur áfram",
      innovation: {
        title: "Nýsköpun",
        description: "Við erum alltaf að leita nýrra leiða til að bæta þjónustu okkar og innleiða nýjustu tækni."
      },
      trust: {
        title: "Traust",
        description: "Við byggjum upp langtímasambönd við viðskiptavini okkar með gagnsæi og áreiðanleika."
      },
      excellence: {
        title: "Framúrskarandi þjónusta",
        description: "Við leggjum okkur fram við að veita framúrskarandi þjónustu og fara fram úr væntingum."
      },
      technology: {
        title: "Tæknilegt forskot",
        description: "Við nýtum gervigreind og nýjustu tækni til að skapa betri lausnir fyrir viðskiptavini."
      }
    },
    stats: {
      founded: "Stofnað",
      locations: "Starfsstöðvar",
      service: "Þjónusta",
      clients: "Ánægðir viðskiptavinir"
    },
    milestones: {
      title: "Tímamót í sögu okkar",
      description: "Lykiláfangar í þróun fyrirtækisins í gegnum árin",
      items: {
        "2006": {
          title: "Stofnun Vefsíðu",
          description: "Fyrirtækið var stofnað með það að markmiði að hjálpa fyrirtækjum að bæta sýnileika sinn á netinu."
        },
        "2010": {
          title: "Fyrsta stóra verkefnið",
          description: "Unnum að stærsta verkefni okkar hingað til fyrir leiðandi fyrirtæki á Íslandi."
        },
        "2015": {
          title: "Alþjóðleg útrás",
          description: "Hófum að vinna með erlendum viðskiptavinum og stækkuðum teymið."
        },
        "2020": {
          title: "Dreift teymi",
          description: "Tókum stefnumarkandi ákvörðun um að verða dreift teymi með starfsstöðvar í þremur löndum."
        },
        "2023": {
          title: "AI innleiðing",
          description: "Hófum að nota gervigreind markvisst í okkar lausnum til að auka skilvirkni og gæði."
        }
      }
    },
    cta: {
      title: "Viltu vinna með okkur?",
      description: "Hafðu samband og við finnum bestu lausnina fyrir þitt fyrirtæki",
      button: "Hafa samband"
    }
  },
  en: {
    title: "Leading in Digital Solutions Development",
    description: "We have been at the forefront of digital solutions development for almost two decades. With a distributed team across three countries and a focus on innovation, we are ideally positioned to help businesses succeed in the digital world.",
    history: {
      title: "Our History and Evolution",
      description: "Vefsíða has been a leader in digital solutions development since 2006. For many years, we were based in Reykjavik, but in 2020 we made the strategic decision to become a distributed team after experiencing increased productivity and better results during remote work during Covid.",
      current: "Today, our headquarters are distributed worldwide, with offices in Reykjavik, Copenhagen, and Barcelona. We specialize in using artificial intelligence to maximize efficiency and innovation in our digital solutions."
    },
    values: {
      title: "Our Values",
      description: "We build all our work on strong values that guide us forward",
      innovation: {
        title: "Innovation",
        description: "We are always looking for new ways to improve our services and implement the latest technology."
      },
      trust: {
        title: "Trust",
        description: "We build long-term relationships with our clients through transparency and reliability."
      },
      excellence: {
        title: "Excellence",
        description: "We strive to provide outstanding service and exceed expectations."
      },
      technology: {
        title: "Technical Edge",
        description: "We utilize AI and the latest technology to create better solutions for our clients."
      }
    },
    stats: {
      founded: "Founded",
      locations: "Locations",
      service: "Service",
      clients: "Happy Clients"
    },
    milestones: {
      title: "Our Milestones",
      description: "Key milestones in the company's development through the years",
      items: {
        "2006": {
          title: "Vefsíða Founded",
          description: "The company was founded with the goal of helping businesses improve their online visibility."
        },
        "2010": {
          title: "First Major Project",
          description: "Completed our largest project to date for a leading company in Iceland."
        },
        "2015": {
          title: "International Expansion",
          description: "Started working with international clients and expanded our team."
        },
        "2020": {
          title: "Distributed Team",
          description: "Made the strategic decision to become a distributed team with offices in three countries."
        },
        "2023": {
          title: "AI Implementation",
          description: "Started systematically using artificial intelligence to increase efficiency and quality."
        }
      }
    },
    cta: {
      title: "Want to work with us?",
      description: "Contact us and we'll find the best solution for your business",
      button: "Contact Us"
    }
  },
  es: {
    title: "Líderes en Desarrollo de Soluciones Digitales",
    description: "Hemos estado a la vanguardia del desarrollo de soluciones digitales durante casi dos décadas. Con un equipo distribuido en tres países y un enfoque en la innovación, estamos idealmente posicionados para ayudar a las empresas a tener éxito en el mundo digital.",
    history: {
      title: "Nuestra Historia y Evolución",
      description: "Vefsíða ha sido líder en el desarrollo de soluciones digitales desde 2006. Durante muchos años, estuvimos basados en Reykjavik, pero en 2020 tomamos la decisión estratégica de convertirnos en un equipo distribuido después de experimentar una mayor productividad y mejores resultados durante el trabajo remoto durante Covid.",
      current: "Hoy, nuestras oficinas centrales están distribuidas mundialmente, con oficinas en Reykjavik, Copenhague y Barcelona. Nos especializamos en el uso de inteligencia artificial para maximizar la eficiencia y la innovación en nuestras soluciones digitales."
    },
    values: {
      title: "Nuestros Valores",
      description: "Construimos todo nuestro trabajo sobre valores sólidos que nos guían hacia adelante",
      innovation: {
        title: "Innovación",
        description: "Siempre buscamos nuevas formas de mejorar nuestros servicios e implementar la última tecnología."
      },
      trust: {
        title: "Confianza",
        description: "Construimos relaciones a largo plazo con nuestros clientes a través de la transparencia y la fiabilidad."
      },
      excellence: {
        title: "Excelencia",
        description: "Nos esforzamos por proporcionar un servicio sobresaliente y superar las expectativas."
      },
      technology: {
        title: "Ventaja Técnica",
        description: "Utilizamos IA y la última tecnología para crear mejores soluciones para nuestros clientes."
      }
    },
    stats: {
      founded: "Fundado",
      locations: "Ubicaciones",
      service: "Servicio",
      clients: "Clientes Satisfechos"
    },
    milestones: {
      title: "Nuestros Hitos",
      description: "Hitos clave en el desarrollo de la empresa a través de los años",
      items: {
        "2006": {
          title: "Fundación de Vefsíða",
          description: "La empresa fue fundada con el objetivo de ayudar a las empresas a mejorar su visibilidad en línea."
        },
        "2010": {
          title: "Primer Proyecto Mayor",
          description: "Completamos nuestro proyecto más grande hasta la fecha para una empresa líder en Islandia."
        },
        "2015": {
          title: "Expansión Internacional",
          description: "Comenzamos a trabajar con clientes internacionales y expandimos nuestro equipo."
        },
        "2020": {
          title: "Equipo Distribuido",
          description: "Tomamos la decisión estratégica de convertirnos en un equipo distribuido con oficinas en tres países."
        },
        "2023": {
          title: "Implementación de IA",
          description: "Comenzamos a utilizar sistemáticamente la inteligencia artificial para aumentar la eficiencia y la calidad."
        }
      }
    },
    cta: {
      title: "¿Quieres trabajar con nosotros?",
      description: "Contáctanos y encontraremos la mejor solución para tu empresa",
      button: "Contáctanos"
    }
  },
  da: {
    title: "Førende inden for Udvikling af Digitale Løsninger",
    description: "Vi har været i frontlinjen af digital løsningsudvikling i næsten to årtier. Med et distribueret team på tværs af tre lande og fokus på innovation er vi ideelt positioneret til at hjælpe virksomheder med at få succes i den digitale verden.",
    history: {
      title: "Vores Historie og Udvikling",
      description: "Vefsíða har været førende inden for udvikling af digitale løsninger siden 2006. I mange år var vi baseret i Reykjavik, men i 2020 tog vi den strategiske beslutning om at blive et distribueret team efter at have oplevet øget produktivitet og bedre resultater under fjernarbejde under Covid.",
      current: "I dag er vores hovedkvarter distribueret verden over, med kontorer i Reykjavik, København og Barcelona. Vi specialiserer os i at bruge kunstig intelligens til at maksimere effektivitet og innovation i vores digitale løsninger."
    },
    values: {
      title: "Vores Værdier",
      description: "Vi bygger alt vores arbejde på stærke værdier, der leder os fremad",
      innovation: {
        title: "Innovation",
        description: "Vi leder altid efter nye måder at forbedre vores services og implementere den nyeste teknologi."
      },
      trust: {
        title: "Tillid",
        description: "Vi opbygger langvarige relationer med vores kunder gennem gennemsigtighed og pålidelighed."
      },
      excellence: {
        title: "Excellence",
        description: "Vi stræber efter at levere fremragende service og overgå forventninger."
      },
      technology: {
        title: "Teknisk Fordel",
        description: "Vi udnytter AI og den nyeste teknologi til at skabe bedre løsninger for vores kunder."
      }
    },
    stats: {
      founded: "Grundlagt",
      locations: "Lokationer",
      service: "Service",
      clients: "Tilfredse Kunder"
    },
    milestones: {
      title: "Vores Milepæle",
      description: "Vigtige milepæle i virksomhedens udvikling gennem årene",
      items: {
        "2006": {
          title: "Vefsíða Grundlagt",
          description: "Virksomheden blev grundlagt med målet om at hjælpe virksomheder med at forbedre deres online synlighed."
        },
        "2010": {
          title: "Første Store Projekt",
          description: "Gennemførte vores største projekt til dato for en førende virksomhed i Island."
        },
        "2015": {
          title: "International Ekspansion",
          description: "Begyndte at arbejde med internationale kunder og udvidede vores team."
        },
        "2020": {
          title: "Distribueret Team",
          description: "Tog den strategiske beslutning om at blive et distribueret team med kontorer i tre lande."
        },
        "2023": {
          title: "AI Implementering",
          description: "Begyndte systematisk at bruge kunstig intelligens til at øge effektivitet og kvalitet."
        }
      }
    },
    cta: {
      title: "Vil du arbejde med os?",
      description: "Kontakt os, og vi finder den bedste løsning for din virksomhed",
      button: "Kontakt Os"
    }
  }
};